import { actionCopyIt } from "./actionCopy";
import { listCopyIt } from "./listCopy";

export const patientsCopyIt = {
    patients: "Pazienti",
    navPatientsDescription: "Gestisca tutti i Suoi pazienti in un unico posto.",
    patientFallback: "Paziente",
    action: "Azione",
    trackerEntry: "Inserimento di monitoraggio",
    patientsError: "Errore pazienti",
    error: "Errore",
    tabActive: "Attivi",
    tabPending: "In attesa",
    tabInactive: "Inattivi",
    search: actionCopyIt.search,
    searchPatientsAria: "Cercare pazienti",
    searchForPatient: "Cercare un paziente",
    searchDescription: "Cerchi per nome, e-mail, data di nascita, numero di cartella ospedaliera o nome del diario",
    searchPlaceholder: "Cercare per nome, e-mail, data di nascita, numero di cartella...",
    noResultsFound: "Nessun risultato",
    trySearchingHint: "Provi a cercare per nome, e-mail, data di nascita o numero di cartella ospedaliera",
    enterSearchTerm: "Inserisca un termine di ricerca per trovare pazienti",
    loadingDiaries: "Caricamento dei diari...",
    errorLoadingDiaries: (message) => `Errore durante il caricamento dei diari: ${message}`,
    unknownPatient: "Paziente sconosciuto",
    dateOfBirthLabel: "Data di nascita",
    noDiariesOnPage: "Nessun diario in questa pagina",
    showingDiaries: (start, end, total) => `Diari da ${start} a ${end} di ${total}`,
    patientsPerPage: "Pazienti per pagina",
    emptyFirstPatientTitle: "Inviti il Suo primo paziente",
    emptyFirstPatientDescription:
        "Scelga una configurazione di diario, verifichi i dettagli, quindi invii un invito. Il suo andamento comparirà qui.",
    emptyFirstPatientCta: "Aggiungere il Suo primo diario",
    emptyFirstPatientHelpLink: "Come invitare un paziente?",
    emptyTabTitle: (tabLabel) => `Nessun diario ${tabLabel.toLowerCase()}`,
    emptyTabDescription:
        "I diari delle altre schede restano disponibili. Cambi scheda, oppure inviti un altro paziente.",
    notDefined: "Non definito",
    columnDiaryStatus: "Stato del diario",
    columnStartDate: "Data di inizio",
    columnPatientName: "Nome del paziente",
    columnOrganisation: listCopyIt.organisation,
    columnLabels: listCopyIt.labels,
    columnDateOfBirth: listCopyIt.dateOfBirth,
    columnHospitalNumber: "Numero di cartella ospedaliera",
    columnRead: "Revisionato",
    filters: actionCopyIt.filters,
    filterDiariesAria: "Filtrare i diari",
    viewSettings: "Impostazioni di visualizzazione",
    viewSettingsDescription:
        "Scelga l'ambito dei diari, lo stato, i clinici con cui sono condivisi, le etichette e i filtri di organizzazione per questo elenco.",
    sharedWithClinicians: "Condiviso con clinici",
    diaryStatus: "Stato del diario",
    selectStatuses: "Selezionare stati",
    labels: listCopyIt.labels,
    organisation: listCopyIt.organisation,
    save: actionCopyIt.save,
    apply: actionCopyIt.apply,
    sortDiariesTitle: "Ordinare i diari",
    sortDiariesDescription:
        "Scelga il campo e l'ordine per questo elenco. L'ordinamento si applica a tutti i diari della scheda attuale, non solo a questa pagina.",
    diaryScope: "Ambito dei diari",
    directAccess: "Accesso diretto",
    allDiariesInOrganisation: "Tutti i diari della mia organizzazione",
    selectClinicians: "Selezionare clinici",
    selectLabels: "Selezionare etichette",
    clearFilters: "Cancella filtri",
    labelsEventsAndForms: "Etichette, eventi e moduli",
    emptyFilteredTitle: "Nessun paziente corrisponde a questi filtri",
    emptyFilteredDescription:
        "Questi filtri nascondono tutti i pazienti di questa scheda. Rimuovine uno o cancellali tutti.",
    removeFilterAria: (description: string) => `Rimuovi filtro: ${description}`,
    selectOrganisations: "Selezionare organizzazioni",
    sortDiariesAria: "Ordinare i diari",
    sortBy: "Ordinare per",
    order: "Ordine",
    sortAscending: "Crescente",
    sortDescending: "Decrescente",
    sortState: "Stato",
    sortStartDate: "Data di inizio",
    sortFirstName: "Nome",
    sortLastName: "Cognome",
    sortDateOfBirth: "Data di nascita",
    sortHospitalNumber: "Numero di cartella ospedaliera",
    read: "Revisionato",
    unread: "Non revisionato",
    noDiarySelected: "Nessun diario selezionato",
    refreshDiary: "Aggiornare il diario",
    noDiaryFound: "Nessun diario trovato.",
    diaryCouldNotLoad: "Impossibile caricare il diario.",
    profileCouldNotLoad: "Impossibile caricare il profilo.",
    diaryDetails: "Dettagli del diario",
    patientDetails: "Dettagli del paziente",
    unknownState: "Stato sconosciuto",
    edit: actionCopyIt.edit,
    done: actionCopyIt.done,
    none: actionCopyIt.none,
    contact: "Contatto",
    noContactPerson: "Nessuna persona di contatto",
    lastEntry: (relative) => `Ultimo inserimento ${relative}`,
    diaryOrganisation: "Organizzazione del diario",
    organisationAndContact: "Organizzazione e contatto",
    editCareDetails: "Modificare i dettagli delle cure",
    labelsStudyTrial: "Etichette (studio / sperimentazione)",
    contactName: "Nome del contatto",
    contactLabel: (name) => `Contatto: ${name}`,
    nameLabel: "Nome",
    emailLabel: "E-mail",
    openLink: "Aprire il link",
    dateRangeToNow: (start) => `${start} a oggi`,
    dateRangeTo: (start, end) => `${start} al ${end}`,
    informationToComplete: "Informazioni da completare",
    clinicianTasks: (entryCount, formCount) =>
        `Ha ${entryCount === 1 ? "1 inserimento da compilare" : `${entryCount} inserimenti da compilare`} in ${
            formCount === 1 ? "1 modulo che il team deve compilare." : `${formCount} moduli che il team deve compilare.`
        }`,
    completeNextForm: "Compilare il modulo successivo",
    completeForm: (title) => `Compilare ${title}`,
    questionnaire: "Questionario",
    more: actionCopyIt.more,
    moreActions: "Altre azioni",
    moreActionsAria: "Altre azioni",
    printDiary: "Stampare il diario",
    shareDiary: "Condividere il diario",
    openFullScreen: "Aprire a schermo intero",
    messageHistory: "Cronologia dei messaggi",
    deleteDiary: "Eliminare il diario",
    deleteDiaryTitle: "Eliminare il diario",
    deleteDiaryDescription: "Desidera davvero eliminare questo diario?",
    cancel: actionCopyIt.cancel,
    delete: actionCopyIt.delete,
    updateDiary: "Aggiornare il diario",
    addToDiary: "Aggiungere al diario",
    addEvent: "Aggiungere un evento",
    addConsent: "Aggiungere un consenso",
    addQuestionnaire: "Aggiungere un questionario",
    addFromTemplate: "Aggiungere da un modello",
    addEventDescription: "Aggiunga un intervento e lo associ a una data esistente, oppure ne crei una nuova.",
    addConsentDescription: "Associ un consenso a un intervento, oppure ne aggiunga uno con una data propria.",
    addQuestionnaireDescription: "Aggiunga un questionario e lo associ a una data esistente, oppure ne crei una nuova.",
    addFromTemplateDescription: "Applichi un modello salvato a questo diario.",
    addConsentTitle: "Aggiungere un consenso",
    addConsentDescriptionLong: "Scelga un intervento, oppure aggiunga un consenso con una data propria.",
    selectProcedureDate: "Intervento",
    notForAnEvent: "Senza collegamento a un evento",
    consentDate: "Data",
    noProcedureDatesForConsent: "Aggiunga prima un intervento.",
    addEventFirst: "Aggiunga prima un evento",
    selectConsent: "Consenso",
    selectConsentHelp: "Scelga un consenso pubblicato da aggiungere a questo diario.",
    noPublishedConsents:
        "Nessun consenso pubblicato è disponibile. Un amministratore può pubblicarne uno nel generatore di consensi.",
    consentRoles: "Chi deve firmare",
    consentRolesHelp: "Le persone selezionate saranno invitate a firmare questo consenso.",
    saveConsent: "Aggiungere il consenso",
    savingConsent: "Aggiunta del consenso…",
    existingDateGroup: "È avvenuto nella stessa data di",
    newDate: "Nessuna delle date sopra",
    newDateHelp: "",
    pickExistingDateHelp: "",
    markAsReviewed: "Segnare come esaminato",
    endDiary: "Chiudere il diario",
    reinstate: "Riattivare",
    contactPatient: "Contattare il paziente",
    endDiaryTitle: "Chiudere il diario",
    endDiaryNotifyQuestion: "Desidera informarne il paziente?",
    justEndDiary: "Chiudere senza avvisare",
    endDiaryAndNotify: "Chiudere e avvisare il paziente",
    markReviewedTitle: "Segnare come esaminato",
    markReviewedNotifyQuestion: "Desidera informare il paziente che il suo diario è stato esaminato?",
    justMarkReviewed: "Segnare come esaminato senza avvisare",
    notifyPatient: "Avvisare il paziente",
    from: "Da",
    to: "A",
    subject: "Oggetto",
    emailBody: "Corpo dell'e-mail",
    send: actionCopyIt.send,
    sending: actionCopyIt.sending,
    emailSentSuccess: "E-mail inviata correttamente",
    emailSentDescription: "Il paziente è stato avvisato",
    emailSendFailed: "Invio dell'e-mail non riuscito",
    seeYourPatients: "Vedere i Suoi pazienti",
    seeYourPatientsDescription: "Segua l'andamento dei Suoi pazienti e gestisca i loro diari",
    goToPatients: "Andare ai pazienti",
    goingToPatients: "Reindirizzamento ai pazienti...",
    reliableEmailWarning: "Per una consegna affidabile, consigliamo Gmail, Outlook o iCloud.",
    entryRecordedTitle: "Inserimento salvato correttamente",
    entryRecordedPending: (count) =>
        `Restano ${count} ${count === 1 ? "inserimento in attesa" : "inserimenti in attesa"} per questo paziente. Si assicuri che tutte le valutazioni richieste siano completate.`,
    entryRecordedComplete:
        "Tutti gli inserimenti richiesti per questo paziente sono stati completati. La cartella del paziente è ora aggiornata.",
    continueToNextEntry: "Passare all'inserimento successivo",
    returnToPatient: "Tornare al paziente",
    loadingTemplates: "Caricamento dei modelli…",
    addToDiaryTitle: "Aggiungere al diario",
    addToDiaryDescription: "Aggiunga un intervento, un consenso o un questionario, oppure parta da un modello.",
    addManually: "Aggiungere manualmente",
    addManuallyDescription:
        "Inserisca passo dopo passo i dettagli dell'intervento e del questionario, senza usare un modello.",
    chooseTemplate: "Scegliere un modello",
    chooseTemplateDescription:
        "Selezioni un modello salvato per precompilare i dettagli dell'intervento e del questionario di questo diario.",
    reviewTemplate: "Verificare il modello",
    reviewTemplateDescription: "Confermi i dettagli seguenti prima di aggiungerli a questo diario.",
    confirmAndContinue: "Confermare e continuare",
    notifyPatientTitle: "Avvisare il paziente?",
    intervention: "Intervento",
    openingTemplateProcedure: "Apertura dell'intervento del modello…",
    existingQuestionnaires: "Questionari esistenti",
    continueWithAllQuestionnaires: "Continuare con tutti i questionari",
    upcomingEntries: "Inserimenti imminenti",
    noUpcomingEntries: "Nessun inserimento imminente.",
    moreEntriesSummary: (count) => `... ${count} inserimenti in più ...`,
    unlocks: (date) => `Sbloccato il ${date}`,
    diaryEnded: "Diario chiuso",
    failedToEndDiary: "Chiusura del diario non riuscita",
    tableSettingsSaved: "Impostazioni della tabella salvate",
    diaryAlreadyRead: "Diario già letto",
    diaryReviewedSubject: "Diario esaminato",
    newDiary: "Nuovo diario",
    searchTemplatesPlaceholder: "Cercare per intervento, area o questionario...",
    noTemplatesYet: "Non ha ancora un modello. Ne crei uno per iniziare a invitare pazienti.",
    noTemplatesMatch: "Nessun modello corrisponde alla Sua ricerca.",
    searchTemplatesShort: "Cercare modelli...",
    procedureFilterInjection: "Iniezione",
    procedureFilterSurgery: "Chirurgia",
    procedureFilterShockwave: "Onde d'urto",
    procedureFilterConsultation: "Consulto",
    procedureFilterProduct: "Prodotto",
    checkingActiveQuestionnaires: "Ricerca di questionari attivi...",
    stopQuestionnairesDescription:
        "Interrompa i questionari in corso prima di aggiungerne uno nuovo, oppure continui con tutti i questionari attivi.",
    noActiveQuestionnairesDescription: "Nessun questionario attivo. Continui per aggiungerne uno nuovo.",
    stopping: "Interruzione...",
    stopAllCurrentQuestionnaires: "Interrompere tutti i questionari in corso",
    stopOnly: (name) => `Interrompere solo ${name}`,
    stopJoined: (list) => `Interrompere ${list}`,
    stopTrackerAria: (name) => `Interrompere ${name}`,
    checkingActiveBeforeTemplate: "Ricerca di questionari attivi prima della conferma del modello…",
    templateExistingTrackersDescription:
        "Selezioni quelli che desidera interrompere prima di aggiungere da questo modello, oppure continui con tutti i questionari attivi.",
    newPatientDiary: "Nuovo diario paziente",
    newPatientDiaryDescription: "Scelga un modello, verifichi la configurazione, quindi inviti il Suo paziente.",
    createTemplate: "Creare un modello",
    favourites: "Preferiti",
    allTemplates: "Tutti i modelli",
    needFiltersHint: "Servono filtri o gestire i modelli?",
    browseAllTemplates: "Sfogliare tutti i modelli",
    cc: "Cc",
    saving: "Salvataggio…",
    interventionTypeQuestion: "Che tipo di intervento?",
    selectInterventionRequired: "Selezioni un tipo di intervento",
    questionnairesLabel: "Questionari",
    continueLabel: "Continuare",
    notifyPatientUpdatedDescription:
        "Il modello è stato aggiunto al diario. Desidera inviare un messaggio al paziente su questo aggiornamento?",
    noJustFinish: "No, concludere soltanto",
    yesNotifyPatient: "Sì, avvisare il paziente",
    diaryUpdatedFromTemplate: "Diario aggiornato dal modello",
    couldNotApplyTemplate: "Impossibile applicare il modello",
    updateMessageTitle: "Inviare un messaggio al paziente?",
    updateMessageDescription: "Inviare un messaggio al paziente dopo il salvataggio.",
    noJustSave: "No, salvare soltanto",
    yesSendMessage: "Sì, inviare un messaggio",
    saveAndMessagePatient: "Salvare e scrivere al paziente",
    saveOnly: "Salvare",
    updateQuestionnairesTitle: "Questionari",
    updateQuestionnairesDescription: "Selezioni i questionari e i calendari di monitoraggio",
    selectQuestionnaire: "Selezionare un questionario",
    selectQuestionnaireHelp: "A quali domande deve rispondere il paziente?",
    selectSchedule: "Selezionare un calendario",
    selectScheduleHelp: "Quando deve compilare il questionario il paziente?",
    addAnotherQuestionnaire: "Aggiungere un altro questionario",
    continueWithoutQuestionnaires: "Continuare senza questionari",
    referenceDateTitle: "Data",
    referenceDateDescription: "Definisca la data di inizio del trattamento o del periodo di monitoraggio.",
    contactStepDescription: "Chi è la persona di contatto?",
    questionnaireWithIndex: (index: number) => `Questionario ${index}`,
    setFlag: "Imposta stato",
    editStatus: "Modifica stato",
    setFlagTitle: "Modifica stato",
    setFlagDescription:
        "Questo sostituisce lo stato automatico finché non restituisce il diario al calcolo automatico.",
    flagOnTrack: "Nei tempi",
    flagImproved: "Migliorato",
    flagWorsening: "Nuovo peggioramento",
    flagNotImproving: "Nessun miglioramento",
    flagNoteLabel: "Nota",
    flagNotePlaceholder: "Nota interna facoltativa",
    saveFlag: "Salva stato",
    resumeAutomatic: "Riprendi lo stato automatico",
    resumeAutomaticHint: "Lo stato sarà ricalcolato in base alle voci del paziente.",
    setManually: "Impostato manualmente",
    setManuallyBy: (name) => `Impostato da ${name}`,
    teamRecordTitle: "Registro del team",
    teamRecordPrivate: "Visibile solo ai clinici e agli amministratori. I pazienti non lo vedono mai.",
    notesTitle: "Note (non condivise con il paziente)",
    notesDescription: "Note interne (non condivise con il paziente)",
    noteByline: (author, when) => `Di ${author} ${when}`,
    noteJustNow: "adesso",
    addNote: "Aggiungi nota",
    notePlaceholder: "Scriva una nota interna",
    saveNote: "Salva nota",
    editNote: "Modifica",
    addNoteName: "Aggiungi un nome",
    noteNameLabel: "Nome",
    saveNoteEdit: "Salva",
    deleteNote: "Elimina",
    deleteNoteTitle: "Elimina nota",
    deleteNoteConfirm: "Questa nota verrà rimossa. L'operazione non può essere annullata.",
    noteDeleted: "Nota eliminata",
    couldNotDeleteNote: "Impossibile eliminare la nota",
    cancelNoteEdit: "Annulla",
    noteEdited: "Modificata",
    statusChangedTo: "Stato modificato in",
    statusSetVerb: "ha impostato",
    statusResumed: (name) => `${name} ha riportato questo diario allo stato automatico`,
    noTeamRecord: "Nessuna modifica di stato per il momento.",
    couldNotSaveFlag: "Impossibile salvare lo stato",
    couldNotSaveNote: "Impossibile salvare la nota",
    flagSaved: "Stato salvato",
    noteSaved: "Nota salvata",
};
